module.exports = __webpack_public_path__ + "img/light-mode.103816d4.svg";